<script>
export default {
  name: "TheAchievementTypeSelect",
}
</script>

<template>

  <v-item-group active-class="primary">
    <v-container>
      <v-row>

        <v-col
          cols="12"
        >
          <v-item v-slot="{ active, toggle }">
            <v-card
              class="d-flex align-center"
              dark
              height="80"
              @click="toggle"
            >
              <v-scroll-y-transition>
                <div
                  v-if="active"
                  class="text-h2 flex-grow-1 text-center"
                >
                  Active
                </div>
              </v-scroll-y-transition>
            </v-card>
          </v-item>
        </v-col>

        <v-col
          v-for="n in 1"
          :key="n"
          cols="12"
          md="6"
        >
          <v-item v-slot="{ active, toggle }">
            <v-card
              class="d-flex align-center"
              dark
              height="80"
              @click="toggle"
            >
              <v-scroll-y-transition>
                <div
                  v-if="active"
                  class="text-h2 flex-grow-1 text-center"
                >
                  Active
                </div>
              </v-scroll-y-transition>
            </v-card>
          </v-item>
        </v-col>

        <v-col
          v-for="n in 1"
          :key="n"
          cols="12"
          md="6"
        >
          <v-item v-slot="{ active, toggle }">
            <v-card
              class="d-flex align-center"
              dark
              height="80"
              @click="toggle"
            >
              <v-scroll-y-transition>
                <div
                  v-if="active"
                  class="text-h2 flex-grow-1 text-center"
                >
                  Active
                </div>
              </v-scroll-y-transition>
            </v-card>
          </v-item>
        </v-col>

      </v-row>
    </v-container>
  </v-item-group>

</template>

<style scoped>

</style>